import {
  type ApiClient,
  type TokenStore,
  createApiClient,
  createStorageTokenStore,
} from '@dorixona/api'
import { displayLanguage } from '@dorixona/utils'
import { env } from '../config/env'

export const TOKEN_STORAGE_KEY = 'dorixona.client.tokens'

/** Customer tokens. Admin tokens never work here and vice versa. */
export function createClientTokenStore(storage: Storage = localStorage): TokenStore {
  return createStorageTokenStore(TOKEN_STORAGE_KEY, storage)
}

export interface CreateClientApiOptions {
  baseUrl?: string
  tokenStore?: TokenStore
  onAuthLost?: () => void
}

export function createClientApi(options: CreateClientApiOptions = {}): ApiClient {
  return createApiClient({
    baseUrl: options.baseUrl ?? env.apiBaseUrl,
    tokenStore: options.tokenStore ?? createClientTokenStore(),
    refreshPath: '/auth/refresh',
    onAuthLost: options.onAuthLost,
    // Названия, тексты витрины и сообщения сервер отдаёт на языке интерфейса.
    language: displayLanguage,
  })
}

/** Единственный клиент приложения и хранилище его токенов. */
export const tokenStore = createClientTokenStore()
export const api = createClientApi({ tokenStore })
